/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Guide_When_TitleInputs */

const en_fw_guide_when_title = /** @type {(inputs: Fw_Guide_When_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When does the Firefly Wedding anime air?`)
};

const zh_fw_guide_when_title = /** @type {(inputs: Fw_Guide_When_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`萤火之嫁动画什么时候播出？`)
};

/**
* | output |
* | --- |
* | "When does the Firefly Wedding anime air?" |
*
* @param {Fw_Guide_When_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_guide_when_title = /** @type {((inputs?: Fw_Guide_When_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Guide_When_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_guide_when_title(inputs)
	return zh_fw_guide_when_title(inputs)
});
export { fw_guide_when_title as "fw.guide.when.title" }